




























import { Vue, Component, Watch } from 'vue-property-decorator'

import TheHeader from '@/components/navigation/TheHeader.vue'
import TheFooter from '@/components/navigation/TheFooter.vue'

import config from '@/config'
import CallDetails from '@/views/CallDetails.vue'
import Review from '@/views/Review.vue'
import Confirmation from '@/views/Confirmation.vue'
import Failed from '@/views/Failed.vue'
import { CallDetailsInformation } from './types'

@Component({
  components: {
    TheHeader,
    TheFooter,
    CallDetails,
    Review,
    Confirmation,
    Failed
  }
})
export default class App extends Vue {
  private details: CallDetailsInformation = {
    number: '',
    name: '',
    date: '',
    time: '',
    category: null,
    reason: null,
    isPrerecorded: false
  }

  private step: 'Details' | 'Review' | 'Confirmation' | 'Failed' = 'Details'

  mounted () {
    this.$gtag.event('App Loaded', {
      // eslint-disable-next-line
      event_category: config.isMagenta ? 'T-Mobile' : 'Metro'
    })
  }

  @Watch('step')
  private onStepChange () {
    window.scrollTo({
      top: 0,
      left: 0
    })
  }
}
